const locale = {
  placeholder: "Sélectionner l'heure",
  rangePlaceholder: ['Heure de début', 'Heure de fin']
};
export default locale;